module.exports = __webpack_public_path__ + "img/icon1.c23653cd.svg";